import { NavigateBackLink } from '@exam-center/components';
import {
  ExamLocationManagementRoomRequest,
  useExamRoomRequestInfo,
} from '@exam-center/exam-location-management';
import { useParams } from '@exam-center/router';
import { PageHeader } from '@shared/components';

export default function ExamLocationRequestRoomPage() {
  const { requestId, roomRequestId, examCenterCode } = useParams(
    '/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId',
  );

  const { examRoomRequestInfo } = useExamRoomRequestInfo();

  return (
    <>
      <PageHeader
        title={`ชั้น: ${examRoomRequestInfo.floor} ห้อง: ${examRoomRequestInfo.name ?? '-'} เลขที่ห้อง: ${examRoomRequestInfo.roomNumber ?? '-'}`}
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-location/requests/draft/:requestId'
            params={{ examCenterCode, requestId }}
            label='Back'
          />
        }
      />
      <ExamLocationManagementRoomRequest
        examCenterCode={examCenterCode}
        requestId={requestId}
        roomRequestId={roomRequestId}
      />
    </>
  );
}
